import {
  collection,
  query,
  getDocs,
  where,
  Timestamp,
  addDoc,
} from 'firebase/firestore';
import { db } from '../config/firebase';

const BOOKINGS_COLLECTION = 'bookings';

export const checkRoomAvailability = async (
  roomId: string,
  checkIn: Date,
  checkOut: Date
): Promise<{ available: boolean }> => {
  try {
    const bookingsQuery = query(
      collection(db, BOOKINGS_COLLECTION),
      where('roomId', '==', roomId),
      where('status', 'in', ['confirmed', 'pending'])
    );

    const querySnapshot = await getDocs(bookingsQuery);
    
    // Check for overlaps with existing bookings
    const overlappingBookings = querySnapshot.docs
      .filter(doc => {
        const booking = doc.data();
        const bookingCheckIn = booking.checkIn?.toDate() || new Date(booking.checkIn);
        const bookingCheckOut = booking.checkOut?.toDate() || new Date(booking.checkOut);

        return (checkIn < bookingCheckOut && checkOut > bookingCheckIn);
      });

    return { available: overlappingBookings.length === 0 };
  } catch (error) {
    console.error('Error checking room availability:', error);
    throw error;
  }
};

export const createBooking = async (bookingData: any) => {
  try {
    const now = Timestamp.now();
    const booking = {
      ...bookingData,
      checkIn: Timestamp.fromDate(new Date(bookingData.checkIn)),
      checkOut: Timestamp.fromDate(new Date(bookingData.checkOut)),
      createdAt: now,
      updatedAt: now,
    };
    
    const docRef = await addDoc(collection(db, 'bookings'), booking);
    return docRef.id;
  } catch (error) {
    console.error('Error creating booking:', error);
    throw error;
  }
}; 